import { render, staticRenderFns } from "./DataRelocate.vue?vue&type=template&id=17fae24c&"
import script from "./DataRelocate.vue?vue&type=script&lang=js&"
export * from "./DataRelocate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports